import React, {useContext, useEffect, useRef, useState} from 'react'
import {useParams} from "react-router";
import Loading from "components/Loading";
import GridBlock from "components/GridBlock";
import {connect} from "react-redux";
import scrollTo from "libs/scrollTo";
import DemandOffersOfferService from "services/DemandOffersOfferService";
import GeneralInfoEntry from "../generalInfo/components/GeneralInfoEntry";
import Tr from 'translations/Translations'
import OfferFiles from "./components/files/OfferFiles";
import OfferEspd from "./components/espd/OfferEspd";
import {ContractorOfferEspdType} from "constants/ContractorOfferEspdType";
import OfferPositions from "./components/positions/OfferPositions";
import NavigationBar from "components/complex/floatingMenu/NavigationBar";
import {makeStyles} from "@material-ui/core";
import createButton from "components/complex/floatingMenu/createButton";
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CancelIcon from '@material-ui/icons/Cancel';
import {DemandValidationSectionStatus} from "constants/DemandValidationSectionStatus";
import {
    OfferPositionStatusesReadyToDelete,
    OfferPositionStatusesReadyToOffering,
    OfferPositionStatusesReadyToWithdraw
} from "../../common/constants/OfferPositionStatusType";
import OfferPositionsSelectPopup, {POPUP_MODE} from "../../common/OfferPositionsSelectPopup";
import useSignature from "hooks/useSignature";
import {OfferStatusType} from "../../common/constants/OfferStatusType";
import SignatureIcon from "components/icon/SignatureIcon";
import PropTypes from "prop-types";
import {StageSectionsUrlParams} from "../../../constants/StageSections";
import {OfferMode} from "../../common/constants/OfferMode";
import OfferSectionContext from "context/OfferSectionContext";
import useLoadingScreen from "hooks/useLoadingScreen";
import {simpleAlert} from "libs/AlertNotification";
import {simpleConfirmNoTranslate} from "libs/ConfirmNotification";
import OfferCommonData, {CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID} from "./components/commonData/OfferCommonData";
import OfferContractorData from "../../common/contractorData/OfferContractorData";
import PurchaserOfferContext from "context/PurchaserOfferContext";
import SnapshotListPopup, {getConfig} from "./components/SnapshotListPopup";
import {RoundType} from "constants/RoundType";
import VerificationsPopup, {getVerificationConfig} from "./components/VerificationsPopup";
import MultiButton, {createButton as createMultiButton} from "components/popup/components/MultiButton";
import HistoryIcon from "@material-ui/icons/History";
import useSalesNotification from "hooks/useSalesNotification";
import salesNotificationKeys from "components/popup/salesNotification/constants/salesNotification.keys";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import HelpTooltip from "components/HelpTooltip";
import VerificationBeforePlaceOfferPopup, {getVerificationBeforePlaceOfferPopupConfig} from "./components/VerificationBeforePlaceOfferPopup";
import OfferStageTranslationsContext from "context/OfferStageTranslationsContext";
import SupportModeContext from "context/SupportModeContext";
import ImportExportIcon from '@material-ui/icons/ImportExport';
import ImportOfferFormPopup from "./components/ImportOfferFormPopup";
import PrintIcon from '@material-ui/icons/Print';

const useStyle = makeStyles(theme => ({
    root: {
        width: '100%'
    },
    floatingMenu: {
        position: 'sticky',
        zIndex: theme.zIndex.appBar - 1,
        bottom: 0,
        marginTop: theme.spacing()
    },
    menuBarPaper: {
        background: theme.palette.background.default,
        border: `solid 1px ${theme.palette.border.dark}`,
    },
    marginLeft: {
        marginLeft: theme.spacing(2)
    }
}))

function OfferEditPanel(
    {
        panelRef,
        demandHeader,
        offerEdit,
        formSubmit,
        formValues,
    }) {


    const classes = useStyle();
    const params = useParams();
    const demandId = params.id;
    const stageId = params.stageId;
    const section = params.section;
    const mode = section === StageSectionsUrlParams.OFFER_EDIT ? OfferMode.EDIT : OfferMode.PLACED;
    const contextSection = useContext(OfferSectionContext);
    const supportMode = useContext(SupportModeContext);
    const stageTr = useContext(OfferStageTranslationsContext);
    const purchaserOfferContext = useContext(PurchaserOfferContext);
    const disabled = offerEdit ? offerEdit.disabled : true;
    const dataLoading = !offerEdit || !demandHeader;
    const positionsRef = useRef();
    const {showLoadingScreen, hideLoadingScreen} = useLoadingScreen();
    const [choosePositionPopup, setChoosePositionPopup] = useState(null);
    const [chooseSnapshotPopup, setChooseSnapshotPopup] = useState(null);
    const [importTemplatePopup, setImportTemplatePopup] = useState(false);
    const [verifyPopup, setVerifyPopup] = useState(null);
    const [verifyBeforePlacePopup, setVerifyBeforePlacePopup] = useState(null);

    useStepperStateCloseValidator(CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID, () => {
        return !(formValues[CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID + "_dirty"] || offerEdit.positions.findIndex(x => !!formValues["offerPositionForm_" + x.positionId + "_dirty"]) > -1)

    })

    const {doSignDocContent, breakSigning} = useSignature()

    useEffect(() => {
            if (!dataLoading) {
                setTimeout((elem) => scrollTo(elem), 100, panelRef.current);
            }
        }
        // eslint-disable-next-line
        , [dataLoading])

    useEffect(() => {
        DemandOffersOfferService.getOfferEdit(demandId, stageId, mode, purchaserOfferContext?.supplierId, purchaserOfferContext?.preview);
        return () => {
            DemandOffersOfferService.clearResources(DemandOffersOfferService.OFFER_EDIT);
        }
        // eslint-disable-next-line
    }, [demandId, stageId, section])


    const placeOffer = () => {
        if (formValues[CONTRACTOR_OFFER_EDIT_COMMON_DATA_FORM_ID + "_dirty"]) {
            simpleAlert(Tr("save_form_x", {name: 'contractor_company_data'}, true), false)
            scrollTo(panelRef.current);
        } else if (offerEdit.commonData.status !== DemandValidationSectionStatus.OK) {
            simpleAlert(Tr("fill_missing_data_x", {name: 'contractor_company_data'}, true), false);
            scrollTo(panelRef.current);
        } else {
            const unsavedPos = offerEdit.positions.find(x => !!formValues["offerPositionForm_" + x.positionId + "_dirty"])
            if (unsavedPos) {
                simpleAlert(Tr("save_form_x", {name: Tr("part_x", {x: unsavedPos.order}) + ": " + unsavedPos.name}), false)
                scrollTo("#offerPositionForm_" + unsavedPos.positionId, 60);
            } else {

                const readyPositions = offerEdit.positions.filter(x => OfferPositionStatusesReadyToOffering.includes(x.status));
                if (readyPositions.length === 0) {
                    simpleAlert("fill_at_least_one_position");
                    scrollTo(positionsRef.current);
                } else {
                    if (contextSection.onePositionMode) {
                        simpleConfirmNoTranslate(stageTr(!purchaserOfferContext ? "place_offer_confirm" : "place_offer_confirm_operator"), () => submitChoosePositions([readyPositions[0].positionId]))
                    } else {
                        setChoosePositionPopup(purchaserOfferContext ? POPUP_MODE.OPERATOR_PLACE : POPUP_MODE.OFFER);
                    }
                }
            }
        }
    }

    const withdrawOffer = () => {
        if (contextSection.onePositionMode) {
            simpleConfirmNoTranslate(stageTr("withdraw_offer_confirm"), () => submitChoosePositionsWithdraw([offerEdit.positions[0].positionId]))
        } else {
            setChoosePositionPopup(POPUP_MODE.WITHDRAW);
        }
    }

    const deleteOffer = () => {
        if (contextSection.onePositionMode) {
            simpleConfirmNoTranslate(stageTr("delete_offer_confirm"), () => submitDeleteOffer([offerEdit.positions[0].positionId]))
        } else {
            setChoosePositionPopup(POPUP_MODE.DELETE_OFFER);
        }
    }

    const submitChoosePositions = (positionIds) => {
        //walidacja dodania espd
        let espdComplete = true;
        if (offerEdit.offerEspdType === ContractorOfferEspdType.YES) {
            if (offerEdit.espdOnPositions) {
                const missing = positionIds.filter(posId => offerEdit.espdFiles.findIndex(f => f.positionId === posId) < 0);
                if (missing.length > 0) {
                    espdComplete = false;
                    const missingPos = offerEdit.positions.find(x => x.positionId === missing[0]) || {};
                    simpleAlert(Tr("save_espd_form_x", {name: Tr("part_x", {x: missingPos.order}) + ": " + missingPos.name}), false)
                }
            } else {
                const espd = offerEdit.espdFiles.findIndex(x => !x.positionId);
                if (espd < 0) {
                    espdComplete = false;
                    simpleAlert("save_espd_form")
                }
            }
        }
        if (espdComplete) {
            if (!purchaserOfferContext && contextSection.digitalSign) {
                DemandOffersOfferService.verifyBeforePlaceOffer(demandId, stageId, undefined, positionIds).then((resp) => {
                    if (resp.success && resp.result.length > 0) {
                        setVerifyBeforePlacePopup(getVerificationBeforePlaceOfferPopupConfig(resp.result, positionIds))
                    } else {
                        doSubmitChoosePositions(positionIds)
                    }
                }).catch((e) => {
                    doSubmitChoosePositions(positionIds);
                    console.error(e)
                })

            } else {
                doSubmitChoosePositions(positionIds)
            }
        }
    }

    const doSubmitChoosePositions = (positionIds) => {
        if (!purchaserOfferContext && contextSection.digitalSign) {
            doSignDocContent(
                contextSection.signatureTypes,
                async (sigType) => {
                    const result = await DemandOffersOfferService.getDocumentToSign(demandId, stageId, {positionIds, signatureType: sigType});
                    if (!result)
                        breakSigning();
                    return result;

                },
                (signatureType, signature, signatureFileId) => {
                    breakSigning();
                    submitPlaceOffer(positionIds, signatureType, signature, signatureFileId)
                },
                (error) => {
                    console.error(error)
                    simpleAlert("signature_error");
                    breakSigning();
                },
                () => {
                    breakSigning();
                },
                async () => contextSection.encryptionEnabled ? contextSection.roundId : null,
            )
        } else {
            submitPlaceOffer(positionIds);
        }

    }

    const submitChoosePositionsWithdraw = (positionIds) => {
        if (contextSection.digitalSign) {
            doSignDocContent(
                contextSection.signatureTypes,
                async (sigType) => {
                    const result = await DemandOffersOfferService.getDocumentToWithdraw(demandId, stageId, {positionIds, signatureType: sigType});
                    if (!result)
                        breakSigning();
                    return result;

                },
                (signatureType, signature, signatureFileId) => {
                    breakSigning();
                    submitWithdrawOffer(positionIds, signatureType, signature, signatureFileId)
                },
                (error) => {
                    console.error(error)
                    simpleAlert("signature_error");
                    breakSigning();
                },
                () => {
                    breakSigning();
                },
                async () => {
                    const result = await DemandOffersOfferService.requireWithdrawEncryption(demandId, stageId, positionIds);
                    if (!result) {
                        breakSigning();
                    } else if (result.requireEncryption) {
                        return result.roundId;
                    } else {
                        return null;
                    }
                }
            )
        } else {
            submitWithdrawOffer(positionIds);
        }
    }

    const signOffer = () => {
        doSignDocContent(
            contextSection.signatureTypes,
            async (sigType) => {
                const result = await DemandOffersOfferService.getDocumentToSign(demandId, stageId, {positionIds: null, signatureType: sigType});
                if (!result)
                    breakSigning();
                return result;

            },
            (signatureType, signature, signatureFileId) => {
                breakSigning();
                showLoadingScreen();
                DemandOffersOfferService.signOffer(demandId, stageId, {
                    positionIds: null,
                    signatureType,
                    signature,
                    signatureFileId
                }, contextSection.onePositionMode, stageTr).finally(hideLoadingScreen)
            },
            (error) => {
                console.error(error)
                simpleAlert("signature_error");
                breakSigning();
            },
            () => {
                breakSigning();
            },
            async () => contextSection.encryptionEnabled ? contextSection.roundId : null,
        )
    }

    const printOfferPosition = () => {
        DemandOffersOfferService.printOfferPosition(demandId, stageId, mode, offerEdit.positions[0].positionId, purchaserOfferContext?.supplierId, purchaserOfferContext?.preview)
    }
    const signWithdrawOffer = () => {
        doSignDocContent(
            contextSection.signatureTypes,
            async (sigType) => {
                const result = await DemandOffersOfferService.getDocumentToWithdraw(demandId, stageId, {positionIds: null, signatureType: sigType});
                if (!result)
                    breakSigning();
                return result;

            },
            (signatureType, signature, signatureFileId) => {
                breakSigning();
                showLoadingScreen()
                DemandOffersOfferService.signWithdraw(demandId, stageId, {
                    positionIds: null,
                    signatureType,
                    signature,
                    signatureFileId
                }, contextSection.onePositionMode, stageTr)
                    .finally(hideLoadingScreen)
            },
            (error) => {
                console.error(error)
                simpleAlert("signature_error");
                breakSigning();
            },
            () => {
                breakSigning();
            },
            async () => {
                const result = await DemandOffersOfferService.requireWithdrawEncryption(demandId, stageId, null);
                if (!result) {
                    breakSigning();
                } else if (result.requireEncryption) {
                    return result.roundId;
                } else {
                    return null;
                }
            }
        )
    }


    const submitPlaceOffer = (positionIds, signatureType, signature, signatureFileId) => {
        showLoadingScreen();
        DemandOffersOfferService.placeOffer(demandId, stageId, purchaserOfferContext?.supplierId, contextSection.onePositionMode, {
            positions: positionIds ? positionIds.map(positionId => ({
                positionId
            })) : null,
            signatureType,
            signature,
            signatureFileId
        }, stageTr).finally(hideLoadingScreen)
    }

    const submitWithdrawOffer = (positionIds, signatureType, signature, signatureFileId) => {
        showLoadingScreen()
        DemandOffersOfferService.withdrawOffer(demandId, stageId, {
                positions: positionIds ? positionIds.map(positionId => ({
                    positionId
                })) : null,
                signatureType,
                signature,
                signatureFileId
            },
            contextSection.onePositionMode, stageTr).finally(hideLoadingScreen)
    }

    const submitDeleteOffer = (positionIds) => {
        showLoadingScreen()
        DemandOffersOfferService.deleteOffer(demandId, stageId, positionIds, stageTr).finally(hideLoadingScreen)
    }

    const stopSigningOperation = (placingOffer) => {
        simpleConfirmNoTranslate(stageTr(placingOffer ? "sign_offer_form_stop_confirm" : "sign_withdraw_form_stop_confirm"), () => {
                showLoadingScreen();
                DemandOffersOfferService.stopSigningOperation(demandId, stageId).finally(hideLoadingScreen)
            }
        )
    }

    const navigationBarButtons = () => {
        const buttons = [];
        if (!disabled && offerEdit.offerStatus === OfferStatusType.NORMAL) {
            if (!purchaserOfferContext && !contextSection.onePositionMode && offerEdit.positions.findIndex(x => OfferPositionStatusesReadyToDelete.includes(x.status)) > -1) {
                buttons.push(createButton(stageTr("delete_offer_position"), deleteOffer, 'outlined', HighlightOffIcon, undefined, supportMode, false, false));
            }
            if (!purchaserOfferContext && offerEdit.positions.findIndex(x => OfferPositionStatusesReadyToWithdraw.includes(x.status)) > -1) {
                buttons.push(createButton(stageTr("withdraw_offer_position"), withdrawOffer, 'outlined', HighlightOffIcon, undefined, supportMode, false, false));
            }
            buttons.push(createButton(stageTr(!purchaserOfferContext ? "place_offer" : "place_offer_operator"), placeOffer, undefined, CheckCircleIcon, 'primary', supportMode || purchaserOfferContext?.preview, false, false));
        }

        if (offerEdit.offerStatus === OfferStatusType.WAITING_SIGNATURE) {
            buttons.push(createButton(stageTr("sign_offer_form_stop"), () => stopSigningOperation(true), 'outlined', CancelIcon, undefined, supportMode, false, false));
            buttons.push(createButton(stageTr("sign_offer_form"), signOffer, undefined, SignatureIcon, 'primary', supportMode, false, false));

        }
        if (offerEdit.offerStatus === OfferStatusType.WAITING_WITHDRAW_SIGNATURE) {
            buttons.push(createButton(stageTr("sign_withdraw_form_stop"), () => stopSigningOperation(false), "outlined", CancelIcon, 'primary', supportMode, false, false));
            buttons.push(createButton(stageTr("sign_withdraw_form"), signWithdrawOffer, undefined, SignatureIcon, 'primary', supportMode, false, false));
        }
        if(purchaserOfferContext?.preview && !offerEdit.passiveOfferForm && offerEdit.positions.length === 1) {
            buttons.push(createButton("download_print", printOfferPosition, undefined, PrintIcon, 'primary', false, true, true));
        }

        return buttons;
    }

    const successPositionsSelectPopup = (positionIds) => {
        ((mode, posIds) => {
            setChoosePositionPopup(null)
            switch (mode) {
                case POPUP_MODE.OFFER:
                case POPUP_MODE.OPERATOR_PLACE:
                    submitChoosePositions(posIds);
                    break;
                case POPUP_MODE.WITHDRAW:
                    submitChoosePositionsWithdraw(posIds);
                    break;
                case POPUP_MODE.DELETE_OFFER:
                    submitDeleteOffer(posIds);
                    break;
                default:
                    throw new Error("Unsupported popup mode: " + mode);

            }
        })(choosePositionPopup, positionIds)
    }
    const printVerificationSalesCheck = useSalesNotification(salesNotificationKeys.SIGNATURE_VERIFICATOR, () => setVerifyPopup(getVerificationConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.BASE)));
    const getButtons = () => {
        const buttons = [];
        if (!purchaserOfferContext?.preview) {
            if (!!purchaserOfferContext && mode === OfferMode.PLACED) {
                buttons.push(createMultiButton(Tr("verify_documents"), printVerificationSalesCheck, undefined, false, undefined, false, SignatureIcon));
            }

            if(!purchaserOfferContext && mode === OfferMode.EDIT && !offerEdit.passiveOfferForm) {
                buttons.push(createMultiButton(Tr("offer_form_import_export"), () => setImportTemplatePopup(true),
                    undefined, disabled, undefined, false, ImportExportIcon));
            }

            buttons.push(createMultiButton(Tr("change_history"), () => setChooseSnapshotPopup(getConfig(demandId, stageId, purchaserOfferContext?.supplierId, RoundType.BASE)),
                "outlined", false, undefined, false, HistoryIcon));

        }
        return buttons;
    }

    return dataLoading ? <Loading/> :
        <div className={classes.root}>
            <GridBlock column>
                <MultiButton buttons={getButtons()}/>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_data')}>
                    <OfferContractorData offerEdit={offerEdit}/>
                </GeneralInfoEntry>

                <GeneralInfoEntry biggerLabel label={Tr('contractor_company_data')}>
                    <OfferCommonData disabled={disabled || mode === OfferMode.PLACED} offerEdit={offerEdit} section={contextSection}/>
                </GeneralInfoEntry>

                {
                    offerEdit.offerEspdType !== ContractorOfferEspdType.NO &&
                    <GeneralInfoEntry biggerLabel label={Tr('jedz_full')}>
                        <OfferEspd roundType={RoundType.BASE} mode={mode} disabled={disabled} offerEdit={offerEdit} section={contextSection} />
                    </GeneralInfoEntry>
                }

                <GeneralInfoEntry biggerLabel label={<>
                    {stageTr("offer_documents")}
                    {(offerEdit.passiveOfferForm || contextSection.digitalSign) &&
                        <HelpTooltip className={classes.marginLeft} dangerouslySetTextHTML={Tr("offer_documents_signature_tooltip_html")}/>}
                </>}>
                    <OfferFiles roundType={RoundType.BASE} mode={mode} disabled={disabled} offerEdit={offerEdit} section={contextSection}/>
                </GeneralInfoEntry>

                {
                    !offerEdit.passiveOfferForm &&
                    <OfferPositions roundType={RoundType.BASE} positionsRef={positionsRef} offerEdit={offerEdit} mode={mode} disabled={disabled}/>
                }

            </GridBlock>

            {
                (!purchaserOfferContext || mode === OfferMode.EDIT) && <div className={classes.floatingMenu}>
                    <NavigationBar buttons={navigationBarButtons()} classesObj={classes}/>
                </div>
            }
            {
                !!choosePositionPopup && <OfferPositionsSelectPopup
                    popupMode={choosePositionPopup}
                    offerEdit={offerEdit}
                    onCancel={() => setChoosePositionPopup(null)}
                    onSuccess={successPositionsSelectPopup}
                    digitalSign={contextSection.digitalSign}
                />
            }
            {
                !!chooseSnapshotPopup && <SnapshotListPopup
                    onClose={() => setChooseSnapshotPopup(null)}
                    config={chooseSnapshotPopup}
                />
            }
            {
                !!verifyPopup && <VerificationsPopup
                    onClose={() => setVerifyPopup(null)}
                    config={verifyPopup}
                />
            }
            {
                !!verifyBeforePlacePopup && <VerificationBeforePlaceOfferPopup
                    onCancel={() => setVerifyBeforePlacePopup(null)}
                    onConfirm={(positionIds) => {
                        setVerifyBeforePlacePopup(null);
                        doSubmitChoosePositions(positionIds);
                    }}
                    config={verifyBeforePlacePopup}
                />
            }
            {
                !!importTemplatePopup && <ImportOfferFormPopup
                    onClose={() => setImportTemplatePopup(false)}
                />
            }
        </div>
}

OfferEditPanel.propTypes = {
    sectionId: PropTypes.string.isRequired
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader,
    offerEdit: state.resources[DemandOffersOfferService.OFFER_EDIT],
    formSubmit: state.form,
    formValues: state.formValues,
}), {})(OfferEditPanel);